import React, {createContext, useEffect, useMemo, useReducer} from 'react';
import Layout from '../Shared/Layout';
import {Container} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import { orderEntryConfig } from "../config/orderEntry";
import BackButton from "../Shared/BackButton";
import {DynamicColorPreset} from "../Shared/DynamicColorPreset";
import { Trans } from "../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import {usePage} from "@inertiajs/inertia-react";
import {orderEntryConfigUnu} from "../config/orderEntryUnu";
import {orderEntryConfigUnzer} from "../config/orderEntryUnzer";
import {orderEntryConfigAmazon} from "../config/orderEntryAmazon";
import {orderEntryConfigNiu} from "../config/orderEntryNiu";
import {orderEntryConfigNiuB2B} from "../config/orderEntryNiuB2B";
import {orderEntryConfigEnfore} from "../config/orderEntryEnfore";
import {orderEntryConfigAmazonNonPaid} from "../config/orderEntryAmazonNonPaid";
import {FormState} from "../FormComponents/FormState";
import classNames from "classnames";
import {orderEntryConfigWorldpay} from "../config/orderEntryWorldpay";
import {orderEntryConfigAmazonLocker} from "../config/orderEntryAmazonLocker";
import {orderEntryConfigNiuDoa} from "../config/orderEntryNiuDoa";
import { orderEntryConfigDemo } from '../config/orderEntryDemo';
import { orderEntryConfigSegwayB2B } from '../config/orderEntrySegwayB2B';
import { orderEntryConfigSegway } from '../config/orderEntrySegway';
import { useSyncOrderState } from '../hooks/useSyncOrderState';
import { orderEntryConfigReturn } from '../config/orderEntryReturn';
import { orderEntryConfigXiaomiB2B } from '../config/orderEntryXiaomiB2B';
import { orderEntryConfigBissellB2B } from '../config/orderEntryBissellB2B';
import { orderEntryConfigBissellCC } from '../config/orderEntryBissellCC';


export const SuccessPage = function ({ response }) {
    const { client } = usePage().props;

    // TODO: Replace this later by calling Inertia::location from the controller
    useEffect(() => {
        if (!response?.checkout_url || !window) return;
        window.location.href = response.checkout_url;
    }, [response?.checkout_url]);


    return (
        <div>
            <h2>
                <Trans i18nKey="formPage.yourOrderHasBeenPlaced">Your Order has been placed</Trans>
            </h2>
            <p><Trans i18nKey="formPage.thanksForYourOrder">Thanks for your Order</Trans></p>
            <p>
                { response?.order?.number }
            </p>
            <p>
                <Trans i18nKey="formPage.thanksInstructions">Please watch your email for further instructions.</Trans>
            </p>
            <MuiButton
                variant="contained"
                color={'secondary'}
                href={route('track.index', { serialnumber: response?.order?.number })}
                onClick={(e) => {
                    e.preventDefault()
                    Inertia.visit(route('track.index', { serialnumber: response?.order?.number }));
                }}
            >
                <Trans i18nKey="formPage.trackYourOrder">TRACK YOUR ORDER</Trans>
            </MuiButton>
        </div>
    );
}

export default function OrderEntry({ requesttypes, user, client, orderControllerConfig, }) {
    const page = usePage();
    const { defaultFormValues, defaultOrderEntryState, isMetadataLoading, hasOrderNumber } = useSyncOrderState({
        queryKey: ["order"]
    });

    const formConfig = page.props?.isReturn ? orderEntryConfigReturn : client.key === 'segway' || client.key === 'segway-de' || client.key === 'segway-espt' ? (user ? orderEntryConfigSegwayB2B : orderEntryConfigSegway) : client.key === 'xiaomi' ? orderEntryConfigXiaomiB2B : client.key === 'bissell' ? (page.props?.isCallcenter ? orderEntryConfigBissellCC : orderEntryConfigBissellB2B) : client.key === 'amazon-locker' ? orderEntryConfigAmazonLocker : client.key === 'worldpay' ? orderEntryConfigWorldpay : client.key === 'unu' ? orderEntryConfigUnu : client.key === 'niu' ? (page.props?.isDoa ? orderEntryConfigNiuDoa : user ? orderEntryConfigNiuB2B : orderEntryConfigNiu) : client.key === 'unzer' ? orderEntryConfigUnzer : client.key === 'amazon' ? (user ? orderEntryConfigAmazonNonPaid : orderEntryConfigAmazon) : client.key === 'enfore' ? orderEntryConfigEnfore : client?.key?.substring(0, 5) === "demo_" ? (user ? orderEntryConfig : orderEntryConfigDemo) : orderEntryConfig;
    const defaultState = useMemo( () => {
        return {
            orderControllerConfig: orderControllerConfig ? { enableStepper: !!formConfig.enableStepper, ...orderControllerConfig, } : { enableStepper: !!formConfig.enableStepper, },
            ...(formConfig?.defaultValues ? formConfig.defaultValues : {}),
            ...(formConfig?.initialState ? formConfig.initialState : {}),
        };
    }, []);

    // Since we want to initialize the form and the order state based on the metadata
    // of the order, we need to wait until the metadata is loaded.
    if (hasOrderNumber && isMetadataLoading) {
        return null;
    }

    return (
        <FormState defaultState={{
            ...defaultState,
            ...defaultOrderEntryState,
        }}>
            <div className={classNames('flex items-start justify-center pt-12 -mt-12 pb-24 -mb-24 min-h-full')}>
                <Container maxWidth="md" className="!m-0">
                    { user && <div className={'mb-3'}><BackButton/></div> }
                    {
                        client.key === 'fiserv' &&
                        <div style={{ width: '100%', display: 'inline-block' }}>
                            <img src={'/images/logos/telecash.png'} alt={'TeleCash from Fiserv'} style={{ width: '175px', float: 'right' }}/>
                        </div>
                    }
                    {/*<h1><Trans i18nKey="orderEntry">Order Entry</Trans></h1>*/}
                    <FormPage
                        requesttypes={requesttypes}
                        orderEntryConfig={formConfig}
                        endpointUrl={route('order')}
                        SuccessPage={formConfig?.success || SuccessPage}
                        defaultValues={{
                            ...formConfig.defaultValues,
                            ...defaultFormValues,
                        }}
                        disableShopSyncronizer
                    />
                </Container>
                <div id="sidebar" className="relative" />
            </div>
        </FormState>
    )
}


OrderEntry.layout = page => <Layout children={page} />;
